module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/ogp2-0b26266f8ecedd8a9a7aa1a8cfe08549.png";